<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5JN84XW" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->

<div class="container">
    <div class="col-md-12" id="header">
        <img src="./assets/imagenes agenda virtual/logo_woden.png" alt="">
    </div>
    <div class="col-md-12" id="divider"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="col-md-3 col-sm-3 col-xs-12" id="bannerIzq">
            <img src="./assets/imagenes agenda virtual/frontalderecha.png" alt="">
        </div>
        <div class="col-md-8 col-sm-8 col-xs-12 mt-md-4" id="form">
            <div *ngIf="schedule.customer !== 'MOVISTAR - PERU'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-md-4">
                <p>El registro de visita se realizó satisfactoriamente, indíquele al momento de la llegada del técnico que su número de caso es <b>{{schedule.nroTicket}}</b> .</p>
                <h3>LA PROGRAMACIÓN DE SU VISITA ES:</h3>
                <ul>
                    <li><i class="fa fa-calendar fa-2x"></i> <b> {{schedule.datePickup | date: 'dd/MM/yyyy'}}</b></li>
                    <li><i class="fa fa-clock-o fa-2x"></i><b> {{schedule.workShedule}}</b></li>
                    <li *ngIf="schedule.customer !== 'TIGO CONTROLES' && schedule.customer !== 'TIGO FUENTES'">
                        <i class="fa fa-wifi fa-2x"></i><b> Cantidad de equipos a recoger: {{schedule.quantity}}</b>
                    </li>
                    <li *ngIf="schedule.customer == 'TIGO CONTROLES'">
                        <i class="fa fa-wifi fa-2x"></i><b> Cantidad de controles a entregar: {{schedule.quantity}}</b>
                    </li>
                    <li *ngIf="schedule.customer == 'TIGO FUENTES'">
                        <i class="fa fa-wifi fa-2x"></i><b> Cantidad de fuentes a entregar: {{schedule.quantity}}</b>
                    </li>
                </ul>
                <a href="https://www.woden.com.co">Regresar</a>
            </div>

            <div *ngIf="schedule.customer == 'MOVISTAR - PERU'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background-image: url('https://th.bing.com/th/id/OIG.fUQSvxJLVxlQQmhxz4ga?pid=ImgGn'); background-size: cover; background-repeat: no-repeat; min-height:  45rem;">
                <div class="thank-you-message">
                    <p class="orange-text">¡Muchas gracias por tu <br> Solicitud!</p>
                    <p class="yellow-text">CONTACTAREMOS CONTIGO EN BREVE</p>
                </div>
            </div>

        </div>
    </div>
    <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12" id="foot">
        <img src="./assets/imagenes agenda virtual/frontalinferior.png" alt="">
    </div>
</div>